import { message } from "antd";
import { checkAuthorization } from "../../helpers";
import { domainUrl } from "../../constants";

const ClientDetailView = (id) => {
    const {userToken} = checkAuthorization()
    var myHeaders = new Headers();
    myHeaders.append('Authorization', userToken);
    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return (
        fetch(domainUrl + `/viewClientProject/${id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                return result?.data
            } 
        })
        .catch(error => {
            message.error(error.message || 'Something went wrong');
            return 0
        })
    )
};

const ClientAddReview = () => {
    const {userToken} = checkAuthorization()
    var myHeaders = new Headers();
    myHeaders.append('Authorization', userToken);
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
    };
    return (
        fetch(domainUrl + `/cleintReview`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success(message)
                return 1
            } 
        })
        .catch(error => {
            message.error(error.message || 'Something went wrong');
            return 0
        })
    )
};


const DeleteClient=(Id)=>{
    const {userToken} = checkAuthorization()
    var myHeaders = new Headers();
    myHeaders.append("Content-Type","application/json")
    myHeaders.append('Authorization', userToken);
    var requestOptions = {
      method:'DELETE',
      headers: myHeaders,
      redirect:'follow'
    }
    return(
        fetch(domainUrl + `/deleteClientProject/${Id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success(result?.message)
                return 1
            } 
            else 
                throw result?.message
        })
        .catch(error => {
            message.error(error.message || 'Something went wrong');
            return 0
        })
    )
  }


const ClientPostApi = {
    ClientDetailView,
    DeleteClient,
    ClientAddReview
}

export {ClientPostApi}
